export default __webpack_public_path__ + "static/media/154.58c23de8.jpg";